let language = {
    SIMPLE_CUSTOMIZE_PREVIEW_MODAL_PREVIEW_BTN: "Preview",
    SIMPLE_CUSTOMIZE_PREVIEW_MODAL_CLOSE_PREVIEW_BTN: "Ok",
};

export { language }